/**
 * App launcher catalog and access helpers.
 * Must include every app from appsConfig.APPS so they appear on the launcher.
 * id must match the key in APPS. icon is used by AppsPage AppIcon.
 */
export const appsCatalog = [
  { id: 'mel', name: 'MEL', description: 'Monitoring & Evaluation', path: '/app/mel', roles: [], accent: 'from-emerald-600 to-teal-500', icon: 'mel' },
  { id: 'requisitions', name: 'Requisitions', description: 'Imprest, petty cash, payment voucher, claims.', path: '/app/requisitions', roles: [], accent: 'from-blue-600 to-indigo-500', icon: 'requisitions' },
  { id: 'procurements', name: 'Procurements', description: 'Procurement management.', path: '/app/procurements', roles: [], accent: 'from-violet-600 to-purple-500', icon: 'procurements' },
  { id: 'finance', name: 'Finance', description: 'Budgets, cost centers, currencies and payments.', path: '/app/finance', roles: [], accent: 'from-amber-600 to-orange-500', icon: 'finance' },
  { id: 'members-partner', name: 'Our StakeHolders', description: 'Stakeholder management.', path: '/app/members-partner', roles: [], accent: 'from-cyan-600 to-sky-500', icon: 'members-partner' },
  { id: 'events', name: 'Events', description: 'Event and attendance management.', path: '/app/events', roles: [], accent: 'from-fuchsia-600 to-pink-500', icon: 'events' },
  { id: 'reports', name: 'Reports', description: 'Reports and analytics.', path: '/app/reports', roles: [], accent: 'from-slate-600 to-slate-500', icon: 'reports' },
  { id: 'assets', name: 'Assets', description: 'Asset management.', path: '/app/assets', roles: [], accent: 'from-lime-600 to-green-500', icon: 'assets' },
  { id: 'self-service', name: 'Self Service', description: 'Profile, pay slip, leaves, timesheets and more.', path: '/app/self-service', roles: [], accent: 'from-rose-600 to-pink-500', icon: 'self-service' },
  { id: 'helpdesk', name: 'Help Desk', description: 'Help desk and support.', path: '/app/helpdesk', roles: [], accent: 'from-orange-600 to-amber-500', icon: 'help-desk' },
  { id: 'documents-management', name: 'EDMS', description: 'Documents management.', path: '/app/documents-management', roles: [], accent: 'from-slate-700 to-slate-600', icon: 'documents-management' },
  { id: 'hrm', name: 'HRM', description: 'Human resource management.', path: '/app/hrm', roles: [], accent: 'from-indigo-600 to-blue-500', icon: 'hrm' },
  { id: 'compliance', name: 'Compliance', description: 'Compliance management.', path: '/app/compliance', roles: [], accent: 'from-slate-700 to-slate-600', icon: 'compliance' },
  { id: 'administration', name: 'Administration', description: 'System administration.', path: '/app/administration', roles: [], accent: 'from-slate-700 to-slate-600', icon: 'administration' },
  { id: 'diary', name: 'Diary', description: 'Personal diary and notes.', path: '/app/diary', roles: [], accent: 'from-amber-600 to-yellow-500', icon: 'my-diary' },
  { id: 'docsign', name: 'DocSign', description: 'Document signing engine.', path: '/app/docsign', roles: [], accent: 'from-slate-700 to-slate-600', icon: 'docsign' },
];

export const getAppById = (appId) => appsCatalog.find((app) => app.id === appId) || null;

export const canAccessApp = (user, app) => {
  if (!user || !app) return false;
  const assignedAppIds = Array.isArray(user?.assignedAppIds)
    ? user.assignedAppIds.map((id) => String(id).trim().toLowerCase()).filter(Boolean)
    : [];

  // When role-app mapping is available in auth payload, it is the source of truth.
  if (assignedAppIds.length > 0 || Array.isArray(user?.roleMappedApps)) {
    return assignedAppIds.includes(String(app.id || '').trim().toLowerCase());
  }

  const userRoles = Array.isArray(user?.roles) ? user.roles : [];
  if (!app.roles || app.roles.length === 0) return true;
  return app.roles.some((role) => userRoles.includes(role));
};

export const inferAppIdFromPathname = (pathname) => {
  const path = pathname || '';
  if (path.startsWith('/app/finance') || path.startsWith('/finance')) return 'finance';
  if (path.startsWith('/app/mel')) return 'mel';
  if (path.startsWith('/app/requisitions')) return 'requisitions';
  if (path.startsWith('/app/procurements')) return 'procurements';
  if (path.startsWith('/app/members-partner')) return 'members-partner';
  if (path.startsWith('/app/events') || path.startsWith('/events')) return 'events';
  if (path.startsWith('/app/reports')) return 'reports';
  if (path.startsWith('/app/assets')) return 'assets';
  if (path.startsWith('/app/self-service')) return 'self-service';
  if (path.startsWith('/app/helpdesk')) return 'helpdesk';
  if (path.startsWith('/app/hrm')) return 'hrm';
  if (path.startsWith('/app/administration')) return 'administration';
  if (path.startsWith('/app/documents-management')) return 'documents-management';
  if (path.startsWith('/app/compliance')) return 'compliance';
  if (path.startsWith('/app/diary')) return 'diary';
  if (path.startsWith('/app/docsign')) return 'docsign';
  return null;
};
